import { orderTestServiceCloud } from "@/services/orderTestRequest";

export function getLabProcessingFeeApi(data) {
  return orderTestServiceCloud({
    url: "/chargePage/labProcessingFee",
    method: "post",
    data,
  });
}

export function updateSettingCreditCard(data) {
  return orderTestServiceCloud({
    url: "/chargePage/paymentMethod_setting",
    method: "put",
    data,
  });
}

export function deleteCreditCardById(data) {
  return orderTestServiceCloud({
    url: "/chargePage/paymentMethod",
    method: "delete",
    data,
  });
}

export function saveChargePMToken(data) {
  return orderTestServiceCloud({
    url: "/chargePage/chargePMToken",
    method: "post",
    data,
  });
}

export function getAllCustomerPaymentMethods(getTokenCustomerPM=false) {
    let url =getTokenCustomerPM?"/chargePage/getAllPaymentMethods?getTokenCustomerPM=true":"/chargePage/getAllPaymentMethods"
  return orderTestServiceCloud({
    url: url,
    method: "get",
  });
}

export function getCustomerStaxIdToken() {
  return orderTestServiceCloud({
    url: "/chargePage/getCustomerStaxIdToken",
    method: "get",
  });
}

export function getCustomerAndClinicStaxidToken(){
  return orderTestServiceCloud({
    url: "/chargePage/getCustomerAndClinicStaxIdToken",
    method: "get",
  })
}

export function getNetPayIntervalApi() {
  return orderTestServiceCloud({
    url: "/chargePage/netPayInterval",
    method: "get",
  });
}